import gameTitle from '@/assets/game-title.webp';
import background from '@/assets/background.webp';

interface LoadingScreenProps {
  progress: number;
  message?: string;
  isTestLoading?: boolean;
}

export const LoadingScreen = ({ progress }: LoadingScreenProps) => {
  return (
    <div
      className="absolute inset-0 flex items-center justify-center z-50"
      style={{
        backgroundImage: `url(${background})`,
        backgroundSize: 'cover',
        backgroundPosition: 'top',
        backgroundRepeat: 'no-repeat',
      }}
    >
      {/* Dim overlay to make text more visible */}
      {/* <div className="absolute inset-0 bg-black/40 backdrop-blur-[0.5px]"></div> */}
      {/* Content Container */}
      <div className="relative flex flex-col items-center w-full h-full px-8 safe-area-inset">
        <div className="h-full flex flex-col items-center justify-between space-y-8 pb-10 pt-safe-top">
          {/* Logo Section */}
          <div className="pt-10 px-5">
            <img src={gameTitle} alt="game-title" />
          </div>

          {/* Progress Section */}
          <div className="flex flex-col items-center space-y-4 w-full">
            {/* Loading Text */}
            <div className="text-center space-y-2">
              <p
                className="text-3xl font-black"
                style={{
                  background:
                    'linear-gradient(to bottom, #FF7A00, #FFA500, #FFD700)',
                  WebkitBackgroundClip: 'text',
                  WebkitTextFillColor: 'transparent',
                  backgroundClip: 'text',
                  // filter:
                  //   'drop-shadow(0 4px 12px rgba(0, 0, 0, 0.8)) drop-shadow(0 0 25px rgba(135, 206, 235, 0.8)) drop-shadow(0 0 15px rgba(255, 255, 255, 0.6))',
                  textShadow: 'none',
                  WebkitTextStroke: '0.5px #000',
                }}
              >
                ⚔️ Preparing Battle
              </p>
              <p className="text-xl font-bold text-white/90 drop-shadow-[0_3px_10px_rgba(0,0,0,0.9)]">
                Get ready to defend your territory!
              </p>
            </div>

            {/* Modern Progress Bar - Orange/Gold theme */}
            <div className="w-full px-10">
              <div className="relative h-12 bg-purple-900/30 rounded-full overflow-hidden backdrop-blur-md border border-purple-700/30">
                {/* Animated Background */}
                <div className="absolute inset-0 bg-gradient-to-r from-transparent via-orange-400/20 to-transparent animate-shimmer"></div>

                {/* Progress Fill */}
                <div
                  className="relative h-full rounded-full transition-all duration-500 ease-out flex items-center justify-center"
                  style={{
                    width: `${progress}%`,
                    background:
                      'linear-gradient(to right, #FF7A00, #FFA500, #FFD700)',
                    boxShadow:
                      '0 0 25px rgba(255, 122, 0, 0.8), 0 0 40px rgba(255, 165, 0, 0.6)',
                  }}
                >
                  {/* Progress Percentage Text */}
                  <span
                    className="absolute text-2xl font-black text-white drop-shadow-[0_2px_8px_rgba(0,0,0,0.9)]"
                    style={{
                      left: '50%',
                      transform: 'translateX(-50%)',
                    }}
                  >
                    {progress}%
                  </span>

                  {/* Glow Effect at the End */}
                  <div className="absolute right-0 top-1/2 transform -translate-y-1/2 w-6 h-6 bg-yellow-300 rounded-full blur-md animate-pulse"></div>
                </div>
              </div>
            </div>

            {/* Bottom Tips - Positioned in lower area */}
            <div className="mt-12 hidden">
              <div
                className="flex items-center space-x-6 text-white/90 text-xs font-medium"
                style={{
                  textShadow:
                    '0 0 15px rgba(251, 191, 36, 0.8), 0 4px 12px rgba(0, 0, 0, 0.9), 0 0 30px rgba(245, 158, 11, 0.5)',
                }}
              >
                <div className="flex items-center space-x-2">
                  <div className="w-2 h-2 bg-green-400 rounded-full animate-pulse shadow-[0_0_8px_rgba(34,197,94,0.8)]"></div>
                  <span className="drop-shadow-[0_2px_6px_rgba(0,0,0,0.9)]">
                    🌐 Network Ready
                  </span>
                </div>
                <div className="flex items-center space-x-2">
                  <div className="w-2 h-2 bg-yellow-400 rounded-full animate-pulse shadow-[0_0_8px_rgba(251,191,36,0.8)]"></div>
                  <span className="drop-shadow-[0_2px_6px_rgba(0,0,0,0.9)]">
                    ⚡ Loading Assets
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
